import axios from "../../adminCompenents/config/axiosConfig";

export default class ProductService {
  // 🔹 Récupérer tous les produits
  getAllProducts = async () => {
    try {
      const response = await axios.get(`/products`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des produits : " + error.message
      );
    }
  };
  getBestSellers = async () => {
    try {
      const response = await axios.get(`/products/product/best-sellers`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des best sellers : " + error.message
      );
    }
  };
  getBientotDispo = async () => {
    try {
      const response = await axios.get(`/products/product/bientot-dispo`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des produits bientôt disponibles : " +
          error.message
      );
    }
  };
  getNouveaux = async () => {
    try {
      const response = await axios.get(`/products/product/nouveaux`);
      return response; // <- pour récupérer uniquement les produits
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des produits nouveaux : " +
          error.message
      );
    }
  };
  // 🔹 Récupérer un produit par son ID
  getProductById = async (id) => {
    try {
      const response = await axios.get(`/products/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération du produit : " + error.message
      );
    }
  };

  // 🔹 Créer un nouveau produit
  createProduct = async (productData) => {
    try {
      const response = await axios.post(`/products`, productData);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création du produit : " + error.message
      );
    }
  };

  // 🔹 Mettre à jour un produit
  updateProduct = async (id, productData) => {
    try {
      console.log("ProductService - Updating product:", id);
      console.log("ProductService - URL:", `/products/${id}`);
      console.log("ProductService - Data type:", typeof productData);

      const response = await axios.patch(`/products/${id}`, productData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("ProductService - Update successful:", response);
      return response;
    } catch (error) {
      console.error("ProductService - Update error:", error);
      console.error("ProductService - Error response:", error.response);
      throw new Error(
        "Erreur lors de la mise à jour du produit : " + error.message
      );
    }
  };

  // 🔹 Supprimer un produit
  deleteProduct = async (id) => {
    try {
      const response = await axios.delete(`/products/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression du produit : " + error.message
      );
    }
  };
}
